import styled from '@emotion/styled';
import { Loader } from 'src/domains/layouts/webview/components/loader/Loader';


export const PaysafeLoaderWrapper = styled(Loader, { label: 'PaysafeLoaderWrapper' })`
    justify-content: center;
    left: 0;
    margin: -6px auto auto;
    position: absolute;
    right: 0;
    top: 50%;
`;
